<template>
    <div>
        <chart :includeTotals="true" path="/api/people/GetChartSales"></chart>
    
        <div class="bg-lighter py-2 px-3">
            <div class="radius-normal bg-lightest border-light p-4 my-3">
                <div class="d-flex align-items-center">
                    <ul class="micro-tabs">
                        <li v-for="(tab, key) in tabs" :class="{ active: (key === activeTab) }" @click="toggleTab($event, key)">{{ tab }}</li>
                    </ul>
                    
                    <a class="alt ml-auto" href="#" @click.prevent="viewReport">View report</a>
                </div>

                <div class="micro-tabs-content">
                    <div v-if="activeTab === 0">
                        <table class="table fs-normal">
                            <thead>
                                <th></th>
                                <th>Commissions</th>
                                <th>Unit</th>
                                <th>Amount</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Reservations</td>
                                    <td>0,00€</td>
                                    <td>0</td>
                                    <td>0,00€</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <ul class="top-sales">
                            <li v-for="sale in sales">
                                <img src="/static/images/product1.jpg" class="radius-normal">
                                <div class="bold darker">{{ sale.name }}</div>
                                <div class="bold dark fs-small">{{ sale.tickets }} tickets sold</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Chart from '@/tools/Chart'

    export default {
        data: function() {
            return {
                activeTab: 0,
                tabs: ['Totals', 'Top sales'],
                sales: [
                    { name: 'SBQ - Sunset Beach ...', tickets: 1500 }
                ],
            }
        },
        methods: {
            toggleTab: function(event, key) {
                this.activeTab = key;
            },
            viewReport: function() {

            }
        },
        components: {
            Chart,
        }
    }
</script>



// WEBPACK FOOTER //
// AgentOverview.vue?2f4cf69f